export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
// export const SERVER_URL = "https://localhost:7092/";
export const APP_MANAGER_SERVER_URL = process.env.REACT_APP_MANAGER_SERVER_URL;
export const REACT_APP_RESTO_SERVER_URL = process.env.REACT_APP_RESTO_SERVER_URL;
